<template>
  <div class="container-fluid">
    <div class="row d-flex justify-content-start">
      <div class="col-12 px-0">
        <SectionTitle
          class="responsive-section-title"
          has-line
          content="Información de Servicio a Solicitar"
        />
      </div>
    </div>
    <validation-observer
      ref="formServiceRequest"
      tag="form"
      novalidate
      v-if="!readOnly"
    >
      <div id="dropdown-wrapper" class="row">
        <div class="col-12 col-lg-3 px-0 px-md-3">
          <ValidationProvider v-slot="{ errors }" rules="required">
            <custom-drop-down
              v-model="model.referralType"
              :options="referralTypes"
              label="Tipo de Referido:"
              fieldkey="id"
              fieldname="name"
              placeholder="Seleccione"
              :error="errors[0]"
              :clearable="false"
              :custom-error-msg="'Favor de seleccionar el tipo de referido.'"
              :disabled="readOnly"
            />
          </ValidationProvider>
        </div>
      </div>

      <div class="row mt-2">
        <div class="col-md-6 col-lg-3">
          <ValidationProvider v-slot="{ errors }" rules="required">
            <custom-drop-down
              v-model="model.equipment"
              :options="equipments"
              label="Equipo:"
              fieldkey="id"
              fieldname="name"
              placeholder="Seleccione"
              :error="errors[0]"
              :clearable="false"
              :custom-error-msg="'Favor de seleccionar el equipo.'"
              :disabled="readOnly"
            />
          </ValidationProvider>
        </div>
        <div class="col-md-6 col-lg-4 mt-2 mt-lg-0">
          <validation-provider
            v-slot="{ errors }"
            :rules="model.equipment?.id !== 0 ? '' : 'required'"
          >
            <custom-input
              v-model="model.equipmentName"
              custom-error-msg="El nombre de equipo es requerido."
              :error="errors[0]"
              labelClass="data-name"
              label="Nombre de Equipo:"
              maxlength="500"
              :disabled="model.equipment?.id !== 0 || readOnly"
            />
          </validation-provider>
        </div>
        <div class="col-md-6 col-lg-4 mt-2 mt-lg-0">
          <ValidationProvider v-slot="{ errors }" rules="required">
            <custom-drop-down
              v-model="model.serviceType"
              :options="serviceTypes"
              label="Tipo de Servicio:"
              fieldkey="inputLabel"
              fieldname="name"
              placeholder="Seleccione"
              :error="errors[0]"
              :clearable="false"
              :custom-error-msg="'Favor de seleccionar el tipo de servicio.'"
              :disabled="readOnly"
            />
          </ValidationProvider>
        </div>
        <div class="col-md-6 col-lg-1 mt-4">
          <action-button
            variant="success w-100"
            class="mt-2"
            i="fas fa-file-plus"
            :text="'Añadir'"
            @click="onAddEquipment()"
          />
        </div>
      </div>
    </validation-observer>
    <div class="mt-3">
      <equipment-row
        v-for="(item, index) in equipmentAdded"
        :item="item"
        :index="index"
        :read-only="readOnly"
        @delete="onDeleteEquipment"
      />
      <error
        v-if="!value.hasEquipment"
        variant="no-border"
        :message="
          'Favor de entrar al menos un equipo al solicitar el servicio.'
        "
      />
    </div>
  </div>
</template>

<script>
import SectionTitle from 'SectionTitle';
import CustomDropDown from 'custom-drop-down';
import CustomInput from '@/components/common/CustomInput';
import {
  getReferralTypes,
  getPeiEquipments,
} from '@/modules/request-tech-service-assistance/api';
import referralTypes from '@/utils/constants/pei/referral/referralTypes';
import serviceCategory from '@/utils/constants/pei/referral/serviceCategory';
import alert from 'utils/mixins/alert.mixin.js';
import Error from 'custom-error';
import EquipmentRow from './EquipmentRow';
import ActionButton from 'ActionButton';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import store from '@/store/index';
import serviceTypes from '@/utils/constants/rp/serviceTypes';

export default {
  name: 'ServicesRequestInformationNew',
  mixins: [alert],
  components: {
    SectionTitle,
    CustomDropDown,
    CustomInput,
    Error,
    EquipmentRow,
    ActionButton,
    ValidationObserver,
    ValidationProvider,
  },
  props: {
    value: {
      type: Object,
      default: () => {},
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    'model.referralType': function(newValue, oldValue) {
      this.onReferralTypeChange(newValue, oldValue);
    },
    'model.equipment': function(newValue) {
      if (newValue !== 0) {
        this.model.equipmentName = '';
      }
    },
    value: function() {
      this.setEquipments();
    },
    studentSie: {
      immediate: true,
      handler(val) {
        if (val) {
          localStorage.setItem('SelectedStudentId', String(val));
        }
      },
    },
  },
  data() {
    return {
      model: {
        referralType: null,
        equipment: null,
        equipmentName: null,
        serviceType: null,
      },
      selectedType: null,
      referralTypes: [],
      equipments: [],
      equipmentSections: [
        {
          id: serviceCategory.toCustomize,
          tableType: referralTypes.solicitudServicioRelacionadoEquipo,
          name: 'Personalizar o adaptar el siguiente equipo',
        },
        {
          id: serviceCategory.toRepair,
          tableType: referralTypes.solicitudServicioRelacionadoEquipo,
          name: 'Reparar o reemplazar el siguiente equipo por avería',
        },
        {
          id: serviceCategory.toReplaceForTheft,
          tableType: referralTypes.solicitudServicioRelacionadoEquipo,
          name:
            'Reemplazar el siguiente equipo de asistencia por hurto  (Incluir copia de la querella de la policía)',
        },
        {
          id: serviceCategory.toReplaceForLost,
          tableType: referralTypes.solicitudServicioRelacionadoEquipo,
          name: 'Reemplazar el siguiente equipo de asistencia por pérdida',
        },
        {
          id: serviceCategory.forTechAssistance,
          tableType: referralTypes.solicitudServicioAsistenciaTecnica,
          name:
            'Asesoría o asistencia técnica para la implantación al currículo',
        },
        {
          id: serviceCategory.forTrainning,
          tableType: referralTypes.solicitudServicioRelacionadoEquipo,
          name:
            'Capacitación o adiestramiento del(de los) siguiente(s) equipos(s)',
        },
      ],
      equipmentAdded: [],
    };
  },
  computed: {
    serviceTypes() {
      return this.equipmentSections.filter(
        (x) => x.tableType === this.model.referralType?.id
      );
    },
    studentSie() {
      const fromRoute = Number(this.$route?.params?.studentSieId);
      const fromModel = Number(this.model?.selectedEvaluationDTO?.studentSieId);
      const fromStore = Number(store.getters?.SelectedStudent?.studentId);
      const fromStorage = Number(localStorage.getItem('SelectedStudentId'));

      return (
        (Number.isFinite(fromRoute) && fromRoute) ||
        (Number.isFinite(fromModel) && fromModel) ||
        (Number.isFinite(fromStore) && fromStore) ||
        (Number.isFinite(fromStorage) && fromStorage) ||
        null
      );
    },
    hasEquipment() {
      return this.equipmentAdded.some((x) => x);
    },
  },
  methods: {
    async getReferralTypes() {
      const { data } = await getReferralTypes();
      this.referralTypes = data;
    },
    async getEquipments() {
      await getPeiEquipments(this.studentSie).then(({ data }) => {
        this.equipments = data;
        this.equipments.push({ id: 0, name: 'Otro' });
      });
    },
    async onReferralTypeChange(newSelection, oldSelection) {
      if (
        oldSelection != null &&
        this.selectedType.id != newSelection.id &&
        this.hasEquipment
      ) {
        const answer = await this.ShowCancelModal(
          'Confirmación',
          'Al cambiar la opción seleccionada se eliminarán los datos documentados en la sección de servicios a solicitar. ¿Está seguro que desea descartar la información antes de continuar?'
        );

        if (!answer) {
          this.model.referralType = oldSelection;
          this.selectedType = oldSelection;
          return;
        } else {
          this.clearEquipmentsLists();
        }
      }

      this.selectedType = newSelection;
      this.value.referralType = this.selectedType;
    },
    clearEquipmentsLists() {
      this.equipmentAdded = [];
      this.value.equipmentsToCustomize = [];
      this.value.equipmentsToRepair = [];
      this.value.equipmentsToReplaceForTheft = [];
      this.value.equipmentsToReplaceForLost = [];
      this.value.equipmentsForTechAssistance = [];
      this.value.equipmentsForTrainning = [];
    },
    async onAddEquipment() {
      const isValid = await this.$refs.formServiceRequest.validate();

      if (!isValid) {
        this.ShowToast(
          'Error',
          'Favor completar los campos requeridos para añadir el equipo',
          'error'
        );
        return;
      }

      const equipment =
        this.model.equipment.id === 0
          ? this.model.equipmentName
          : this.model.equipment.name;

      const exist = this.equipmentAdded.find((x) => x.equipment == equipment);

      if (exist) {
        this.ShowToast(
          'Error',
          'El equipo ya se encuentra en la lista',
          'error'
        );
        return;
      }

      const data = {
        equipment: equipment,
        serviceType: this.model.serviceType,
        referralType: this.model.referralType.name,
      };

      this.equipmentAdded.push(data);

      this.addEquipment(equipment, this.model.serviceType.id);
      this.clear();
    },
    onDeleteEquipment(model) {
      this.equipmentAdded.splice(model.index, 1);
      this.ShowToast(
        'Proceso exitoso',
        'Equipo removido correctamente',
        'success'
      );

      this.removeEquipment(model.item.equipment, model.item.serviceType.id);
    },
    addEquipment(item, categoryId) {
      switch (categoryId) {
        case serviceCategory.toCustomize:
          this.value.equipmentsToCustomize.push(item);
          break;
        case serviceCategory.toRepair:
          this.value.equipmentsToRepair.push(item);
          break;
        case serviceCategory.toReplaceForTheft:
          this.value.equipmentsToReplaceForTheft.push(item);
          break;
        case serviceCategory.toReplaceForLost:
          this.value.equipmentsToReplaceForLost.push(item);
          break;
        case serviceCategory.forTechAssistance:
          this.value.equipmentsForTechAssistance.push(item);
          break;
        case serviceCategory.forTrainning:
          this.value.equipmentsForTrainning.push(item);
          break;
        default:
          break;
      }
    },
    removeEquipment(equipment, categoryId) {
      let equipmentIndex = 0;
      switch (categoryId) {
        case serviceCategory.toCustomize:
          equipmentIndex = this.value.equipmentsToCustomize.findIndex(
            (x) => x === equipment
          );

          this.value.equipmentsToCustomize.splice(equipmentIndex, 1);
          break;
        case serviceCategory.toRepair:
          equipmentIndex = this.value.equipmentsToRepair.findIndex(
            (x) => x === equipment
          );

          this.value.equipmentsToRepair.splice(equipmentIndex, 1);
          break;
        case serviceCategory.toReplaceForTheft:
          equipmentIndex = this.value.equipmentsToReplaceForTheft.findIndex(
            (x) => x === equipment
          );

          this.value.equipmentsToReplaceForTheft.splice(equipmentIndex, 1);
          break;
        case serviceCategory.toReplaceForLost:
          equipmentIndex = this.value.equipmentsToReplaceForLost.findIndex(
            (x) => x === equipment
          );

          this.value.equipmentsToReplaceForLost.splice(equipmentIndex, 1);
          break;
        case serviceCategory.forTechAssistance:
          equipmentIndex = this.value.equipmentsForTechAssistance.findIndex(
            (x) => x === equipment
          );

          this.value.equipmentsForTechAssistance.splice(equipmentIndex, 1);
          break;
        case serviceCategory.forTrainning:
          equipmentIndex = this.value.equipmentsForTrainning.findIndex(
            (x) => x === equipment
          );

          this.value.equipmentsForTrainning.splice(equipmentIndex, 1);
          break;
        default:
          break;
      }
    },
    clear() {
      this.model.equipment = null;
      this.model.equipmentName = null;
      this.model.serviceType = null;
      this.$refs.formServiceRequest.reset();
    },
    setEquipments() {
      if (this.readOnly) {
        if (
          this.value.referralTypeId ===
          referralTypes.solicitudServicioRelacionadoEquipo
        ) {
          this.value.equipmentsToCustomize.forEach((equipment) => {
            const data = {
              equipment: equipment.name,
              serviceType: {
                id: serviceCategory.toCustomize,
                name: 'Personalizar o adaptar el siguiente equipo',
              },
              referralType: this.value.referralType.name,
            };

            this.equipmentAdded.push(data);

            this.addEquipment(data.equipment, data.serviceType.id);
          });

          this.value.equipmentsForTrainning.forEach((equipment) => {
            const data = {
              equipment: equipment.name,
              serviceType: {
                id: serviceCategory.forTrainning,
                name:
                  'Capacitación o adiestramiento del(de los) siguiente(s) equipos(s)',
              },
              referralType: this.value.referralType.name,
            };

            this.equipmentAdded.push(data);

            this.addEquipment(data.equipment, data.serviceType.id);
          });

          this.value.equipmentsToReplaceForLost.forEach((equipment) => {
            const data = {
              equipment: equipment.name,
              serviceType: {
                id: serviceCategory.toReplaceForLost,
                name:
                  'Reemplazar el siguiente equipo de asistencia por pérdida',
              },
              referralType: this.value.referralType.name,
            };

            this.equipmentAdded.push(data);

            this.addEquipment(data.equipment, data.serviceType.id);
          });

          this.value.equipmentsToReplaceForTheft.forEach((equipment) => {
            const data = {
              equipment: equipment.name,
              serviceType: {
                id: serviceCategory.toReplaceForTheft,
                name:
                  'Reemplazar el siguiente equipo de asistencia por hurto  (Incluir copia de la querella de la policía)',
              },
              referralType: this.value.referralType.name,
            };

            this.equipmentAdded.push(data);

            this.addEquipment(data.equipment, data.serviceType.id);
          });

          this.value.equipmentsToRepair.forEach((equipment) => {
            const data = {
              equipment: equipment.name,
              serviceType: {
                id: serviceCategory.toRepair,
                name: 'Reparar o reemplazar el siguiente equipo por avería',
              },
              referralType: this.value.referralType.name,
            };

            this.equipmentAdded.push(data);
          });
        } else {
          this.value.equipmentsForTechAssistance?.forEach((equipment) => {
            const data = {
              equipment: equipment.name,
              serviceType: {
                id: serviceCategory.forTechAssistance,
                name:
                  'Asesoría o asistencia técnica para la implantación al currículo',
              },
              referralType: this.value.referralType.name,
            };

            this.equipmentAdded.push(data);

            this.addEquipment(data.equipment, data.serviceType.id);
          });
        }
      }
    },
  },
  async mounted() {
    await Promise.all([this.getReferralTypes(), this.getEquipments()]);
    this.setEquipments();
  },
};
</script>

<style scoped>
::v-deep label.data-name {
  color: #11291b !important;
}

.box-container {
  background-color: #f7f7f7;
  padding: 15px;
  border-radius: 5px;
}

@media only screen and (max-width: 500px) {
  #dropdown-wrapper >>> .vs__selected {
    font: 0.7rem Lato;
  }

  #dropdown-wrapper >>> .vs__dropdown-menu {
    font: 0.7rem Lato;
  }

  .responsive-section-title >>> .tag-badge-title-info {
    font-size: 0.8rem;
  }
}
</style>
